import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../../core/Icon';

export const StyledIcon = styled(Icon)`
  margin-top: ${rem('15px')};
  margin-left: ${rem('15px')};
  &:first-child {
    margin-top: ${rem('0px')};
  }
`;
